const showFormFieldsForAllWhitepaper2024Forms = require("../../run/whitepaper2024/showFormFieldsForAllWhitepaper2024Forms");
const hideAllWhitepaper2024ReturningUserContainersOnThePage = require("../../run/whitepaper2024/hideAllWhitepaper2024ReturningUserContainersOnThePage");

/**
 * @return {void}
 */
module.exports = function whenWhitepaper2024NotYouButtonClicked() {
    hideAllWhitepaper2024ReturningUserContainersOnThePage();
    showFormFieldsForAllWhitepaper2024Forms();
}
